export default __webpack_public_path__ + "static/media/dyer3.01c69910.jpg";